module.exports = __webpack_public_path__ + "img/DSC_0048.a754221a.jpg";